import React from "react";
import { getUserData } from "../../../Common/utils";
import { useSelector } from "react-redux";

const ZapierIntegration = () => {
  const currentUserData = useSelector((s) => s?.currentUser?.userData);
  const userData = currentUserData ? currentUserData : getUserData();

  return (
    <div className="tabsContent">
      <div className="details">
        <div className="appsWrap">
          <zapier-workflow
            sign-up-email={userData?.email}
            sign-up-first-name={userData?.firstName}
            sign-up-last-name={userData?.lastName}
            client-id={process.env.REACT_APP_ZAPPIER_CLIENT_ID}
            theme="light"
            intro-copy-display="show"
            guess-zap-display="show"
          />
        </div>
      </div>
    </div>
  );
};

export default ZapierIntegration;
